import { lazy, Suspense } from "react";

import { cn } from "~/ui";

const CodeMirrorEditor = lazy(async () => {
  const [{ default: CodeMirror }, { json }] = await Promise.all([
    import("@uiw/react-codemirror"),
    import("@codemirror/lang-json"),
  ]);

  function Editor({
    value,
    onChange,
    className,
  }: {
    value: string;
    onChange: (value: string) => void;
    className?: string;
  }) {
    return (
      <CodeMirror
        value={value}
        onChange={onChange}
        extensions={[json()]}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          bracketMatching: true,
          autocompletion: false,
          highlightActiveLine: true,
          highlightActiveLineGutter: true,
          indentOnInput: true,
        }}
        theme="light"
        className={cn("overflow-hidden rounded-lg border border-input text-sm", className)}
        style={{ fontSize: "13px" }}
      />
    );
  }

  return { default: Editor };
});

function EditorSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex min-h-[400px] items-center justify-center rounded-lg border border-input bg-muted/30 font-mono text-sm text-muted-foreground",
        className,
      )}
    >
      Loading editor…
    </div>
  );
}

export function JsonEditor({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <div data-testid="json-editor" className="contents">
      <Suspense fallback={<EditorSkeleton className={className} />}>
        <CodeMirrorEditor value={value} onChange={onChange} className={className} />
      </Suspense>
    </div>
  );
}
